module.exports = __webpack_public_path__ + "img/buzzebees-logo-dark-semi.svg";